import { ColumnSettings, ITableColumn } from '@makyoapp/makyo-sdk/models/Table'

import { Cell, ICell } from '.'
import { IRow } from '../tables/row'
import { TextCell } from './text'

export interface IConnectionColumnSettings extends ColumnSettings {
  foreignColumnID: string
  foreignColumnIDToShow: string
  foreignTableID: string
  localColumnID: string
  matchMultiple: boolean
}

export interface IConnectionColumn extends ITableColumn {
  Settings: IConnectionColumnSettings
}

export interface IConnectionCell extends ICell {
  settings: IConnectionColumnSettings
  cellValues: ICell[]
  matchingRows: IRow[]
}

export class ConnectionCell implements IConnectionCell {
  value: Cell[]
  cellValues: ICell[]
  settings: IConnectionColumnSettings
  // foreignColumn: ITableColumn // foreign column
  matchingRows: IRow[] // matching cells in the foreign table for the current row

  constructor(
    value: Cell[] = [],
    settings: IConnectionColumnSettings,
    cellValues: ICell[] = [],
    /* foreignColumn: ITableColumn,  */
    matchingRows: IRow[] = []
  ) {
    this.value = value || []
    this.settings = settings
    this.cellValues = cellValues
    // this.foreignColumn = foreignColumn
    this.matchingRows = matchingRows
  }

  // Returns the JSON stringified reprensentation of the cells
  toString(): string {
    let value = Array.isArray(this.value) ? this.value : [this.value]
    return JSON.stringify(value.map((cell) => cell?.toString()))
  }

  parse(value: string): ConnectionCell {
    // Attempt to parse the string value
    let parsedValue: string[]

    try {
      parsedValue = JSON.parse(value)
    } catch (e) {
      // If JSON parsing fails, assume the value is a string
      parsedValue = [value]
    }

    if (parsedValue.length !== value.length) {
      throw new Error('The string value does not match the expected format')
    }

    // Convert the parsed value to an array of Cell objects
    this.value = parsedValue.map((cell, index) => {
      const curCell = this.matchingRows[index][this.settings.foreignColumnIDToShow] as ICell
      if (curCell.toCell) {
        // TODO: remove passing the seetings from the interface
        // TODO: brainstorm on the fact that we can have a connection ok a connection
        return curCell.toCell(cell).value as Cell
      }

      // If the cell does not have a toCell method, return the cell as a text cell.
      // TODO: every cell should have a toCell method
      return new TextCell(cell, null).value
    })

    return this
  }

  // ! This should not be used for connection column, use the toMultipleDataCell method instead
  toCell<T extends Cell>(value: T): ConnectionCell {
    return this
  }

  toMultipleDataCell<T extends Cell>(value: T[]): ConnectionCell {
    this.value = value
    return this
  }
}
